"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = void 0;

var _tslib = require("tslib");

var _provider = require("./provider");

var _context = require("./context");

var reducer = function reducer(state, _a) {
  var _b;

  var payload = _a.payload,
      type = _a.type;

  switch (type) {
    case _context.Actions.SET:
      return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), payload);

    case _context.Actions.EMPTY:
      return _provider.initialState;

    case _context.Actions.UNSET:
      {
        var key = payload;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), (_b = {}, _b[key] = _provider.initialState[key], _b));
      }

    default:
      throw new Error("Unsupported action type " + type);
  }
};

exports.reducer = reducer;